<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <h1 class="title">Mountain crew</h1>
      <app-cells>
<!--        <app-button @click.native="$modal.show('crew')">Add crew</app-button>-->
        <app-input
          @input.native="onCrewSearch"
          v-model="search"
          class="input--200"
          type="search"
          placeholder="Search by name"
          name="search"
        />
        <app-filters
          v-model="role_filter"
          :filters="role_filters"
          name="filterRole"
          @change="onChangeRole"
        />
        <app-select
          @input="onChangeFilter"
          v-model="rank_filter"
          :reduce="item => item.code"
          :options="rank_options"
          placeholder="Rank"
          class="select--200"
        />
      </app-cells>
      <v-client-table
        :data="table.items"
        :columns="table.columns"
        :options="table.options"
        class="table-default"
        :class="{ 'table-default--loading': table_preloader }"
      >
        <template #h__name><div class="table-default__left">Name</div></template>
        <template #old_id="{ row }">{{ row.old_id || '-' }}</template>
        <template #name="{ row }">
          <div class="table-default__left table-default__left--photo">
            <div class="table-default__photo">
              <img :src="getUserAvatar(row.crop.crop_url, row.gender?.code || null)" alt="Avatar">
            </div>
            <router-link
                :to="{ name: 'climbing-mountain-crew-profile', params: { id: row.id } }"
                class="table-default__link-border"
            >
              {{ row.full_name }}
            </router-link>
          </div>
        </template>
        <template #age="{ row }">
          <span v-if="row.age" v-tooltip="{ content: dateFormat(row.dob), placement: 'top-start', offset: 10 }">
            {{ row.age }}
          </span>
          <template v-else>-</template>
        </template>
        <template #main_phone="{ row }">
          <div class="table-default__controls">
            <button
                v-tooltip="{content: row.phone, placement: 'top-start', offset: 10}"
                @click="onCopyContactLink(row.phone)"
                class="table-default__activity table-default__activity--phone"
                :class="{'table-default__activity--active': row.phone}"
            >
            </button>
            <a
                :href="`https://t.me/${row.phone}`"
                target="_blank"
                class="table-default__activity table-default__activity--tg"
                :class="{'table-default__activity--active': row.phone_telegram_available}"
            >
            </a>
            <a
                :href="`https://wa.me/${row.phone}`"
                target="_blank"
                class="table-default__activity table-default__activity--wa"
                :class="{'table-default__activity--active': row.phone_whatsapp_available}"
            >
            </a>
          </div>
        </template>
        <template #add_phone="{ row }">
          <div class="table-default__controls">
            <button
                v-tooltip="{content: row.additional_phone, placement: 'top-start', offset: 10}"
                @click="onCopyContactLink(row.additional_phone)"
                class="table-default__activity table-default__activity--phone"
                :class="{'table-default__activity--active': row.additional_phone}"
            >
            </button>
            <a
                :href="`https://t.me/${row.additional_phone}`"
                target="_blank"
                class="table-default__activity table-default__activity--tg"
                :class="{'table-default__activity--active': row.additional_phone_telegram_available}"
            >
            </a>
            <a
                :href="`https://wa.me/${row.additional_phone}`"
                target="_blank"
                class="table-default__activity table-default__activity--wa"
                :class="{'table-default__activity--active': row.additional_phone_whatsapp_available}"
            >
            </a>
          </div>
        </template>
        <template #mountain_phone="{ row }">
          <div class="table-default__controls">
            <button
                v-tooltip="{content: row.mountain_phone, placement: 'top-start', offset: 10}"
                @click="onCopyContactLink(row.mountain_phone)"
                class="table-default__activity table-default__activity--phone"
                :class="{'table-default__activity--active': row.mountain_phone}"
            >
            </button>
            <a
                :href="`https://t.me/${row.mountain_phone}`"
                target="_blank"
                class="table-default__activity table-default__activity--tg"
                :class="{'table-default__activity--active': row.mountain_phone_telegram_available}"
            >
            </a>
            <a
                :href="`https://wa.me/${row.mountain_phone}`"
                target="_blank"
                class="table-default__activity table-default__activity--wa"
                :class="{'table-default__activity--active': row.mountain_phone_whatsapp_available}"
            >
            </a>
          </div>
        </template>
        <template #rank="{ row }">
          <span
              v-if="row.rank"
              class="status-tag"
              :style="{ 'backgroundColor': row.rank.color }"
          >
          {{ row.rank.name }}
        </span>
          <span v-else>-</span>
        </template>
        <template #docs="{ row }">
          <div class="table-default__controls">
            <app-document-icon
                name="national_id"
                :fields="{ id: row.national_id, expire: row.national_id_expire, scan_copy: row.national_id_scancopy }"
                :first_name="row.first_name"
                :last_name="row.last_name"
            />
            <app-document-icon name="voting_card" :fields="{ id: row.voting_card }" />
            <app-document-icon
                name="guide_licence_id"
                :fields="{ id: row.mountain_id, expire: row.mountain_id_expiration_date, scan_copy: row.mountain_id_scancopy }"
                :first_name="row.first_name"
                :last_name="row.last_name"
            />
          </div>
        </template>
        <template #profile="{ row }">
          <div class="table-default__controls">
            <app-document-icon name="bank_account" :fields="{ id: row.bank_account, bank_name: { name: 'NMB' } }"/>
            <app-document-icon
                name="guarantor_employee"
                :fields="{ id: row.guarantor_crew }"
            />
            <app-document-icon
                name="guarantor"
                :fields="{ id: row.guarantor_other }"
            />
          </div>
        </template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPagination"
            v-if="pagination.pages > 1"
            v-model="pagination.page"
            :page-count="pagination.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination.count" :count="table.items.length" :page="pagination.page" :limit="40" />
      </app-cells>
    </template>
<!--    <modal-->
<!--        name="crew"-->
<!--        :width="400"-->
<!--        :height="'auto'"-->
<!--        :scrollable="true"-->
<!--        :adaptive="true"-->
<!--        :clickToClose="false"-->
<!--        class="modal-not-overflow"-->
<!--    >-->
<!--      <div class="popup">-->
<!--        <button @click="$modal.hide('crew')" class="popup__close" type="button"></button>-->
<!--        <div class="popup__title">-->
<!--          <span>New crew</span>-->
<!--        </div>-->
<!--        <div class="popup__body">-->
<!--          <form @submit.prevent="onCheckForm">-->
<!--            <app-form-group label="First name" label-for="first_name" required>-->
<!--              <app-input-->
<!--                  v-model="form.first_name"-->
<!--                  @change.native="$v.form.first_name.$touch()"-->
<!--                  :error="$v.form.first_name.$error"-->
<!--                  id="first_name"-->
<!--                  placeholder="First name"-->
<!--                  name="first_name"-->
<!--              />-->
<!--              <template #error>-->
<!--                <div v-if="$v.form.first_name.$dirty && !$v.form.first_name.required">Required field</div>-->
<!--              </template>-->
<!--            </app-form-group>-->
<!--            <app-form-group label="Middle name" label-for="middle_name">-->
<!--              <app-input-->
<!--                  v-model="form.middle_name"-->
<!--                  id="middle_name"-->
<!--                  placeholder="Middle name"-->
<!--                  name="middle_name"-->
<!--              />-->
<!--            </app-form-group>-->
<!--            <app-form-group label="Last name" label-for="last_name" required>-->
<!--              <app-input-->
<!--                  v-model="form.last_name"-->
<!--                  @change.native="$v.form.last_name.$touch()"-->
<!--                  :error="$v.form.last_name.$error"-->
<!--                  id="last_name"-->
<!--                  placeholder="Last name"-->
<!--                  name="last_name"-->
<!--              />-->
<!--              <template #error>-->
<!--                <div v-if="$v.form.last_name.$dirty && !$v.form.last_name.required">Required field</div>-->
<!--              </template>-->
<!--            </app-form-group>-->
<!--            <app-form-group label="Gender" class="form-group&#45;&#45;center" required>-->
<!--              <app-cells :indent="false">-->
<!--                <app-radio-->
<!--                    v-for="item in genders_options"-->
<!--                    :key="item.code"-->
<!--                    v-model.number="form.gender"-->
<!--                    :value="item.code"-->
<!--                    name="gender"-->
<!--                    :checked="form.gender"-->
<!--                    :error="$v.form.gender.$error"-->
<!--                >-->
<!--                  <template #label>{{ item.name }}</template>-->
<!--                </app-radio>-->
<!--              </app-cells>-->
<!--              <template #error>-->
<!--                <div v-if="$v.form.gender.$dirty && !$v.form.gender.required">Required field</div>-->
<!--              </template>-->
<!--            </app-form-group>-->
<!--            <app-cells position="center" :indent="false">-->
<!--              <app-button :disabled="$v.form.$error" type="submit" ref="submit">Add</app-button>-->
<!--            </app-cells>-->
<!--          </form>-->
<!--        </div>-->
<!--      </div>-->
<!--    </modal>-->
  </div>
</template>

<script>
import {
  getClimbingMountainCrewList,
  getClimbingMountainCrewRanks,
  getClimbingMountainCrewRole,
  getGenders,
} from '@/http'
import { format, parse } from 'date-fns'
import AppDocumentIcon from '@/components/AppDocumentIcon'
import debounce from 'lodash/debounce'
// import { required } from 'vuelidate/lib/validators'

export default {
  name: 'ClimbingMountainCrewList',
  components: { AppDocumentIcon },
  data() {
    return {
      is_loaded: false,
      search: '',
      role_filter: '',
      role_filters: [
        { value: '', label: 'All' },
        { value: 'guide', label: 'Guide' },
        { value: 'cook', label: 'Cook' },
        { value: 'camp_manager', label: 'Camp M.' },
        { value: 'waiter', label: 'Waiter' },
        { value: 'porter', label: 'Porter' }
      ],
      rank_filter: '',
      rank_options: [],
      table_preloader: false,
      table: {
        items: [],
        columns: ['old_id', 'name', 'age', 'role.name', 'main_phone', 'add_phone', 'mountain_phone', 'rank', 'docs', 'profile'],
        options: {
          headings: {
            'old_id': 'ID',
            'name': 'Name',
            'age': 'Age',
            'role.name': 'Role',
            'main_phone': 'Main phone',
            'add_phone': 'Add. phone',
            'mountain_phone': 'Mountain phone',
            'rank': 'Rank',
            'docs': 'Documents',
            'profile': 'Profile',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 40,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      // form: {},
      genders_options: [],
      role_options: [],
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
    }
  },
  // validations: {
  //   form: {
  //     role: { required },
  //     first_name: { required },
  //     last_name: { required },
  //     gender: { required },
  //   }
  // },
  created() {
    this.fetchItems()
    getClimbingMountainCrewRanks().then(res => { this.rank_options = res.data })
    getGenders().then(res => { this.genders_options = res.data })
    getClimbingMountainCrewRole().then(res => { this.role_options = res.data })
  },
  methods: {
    // onCheckForm() {
    //   this.$v.form.$touch()
    //   if (this.$v.form.$invalid) {
    //     this.$notify({
    //       type: 'info',
    //       title: 'Check that the form fields are filled in correctly',
    //     })
    //   } else {
    //     this.sendForm()
    //   }
    // },
    // sendForm() {
    //   this.$refs.submit.preload = true
    //   postClimbingMountainCrew({ ...this.form, role: this.form.role.code })
    //     .finally(() => { this.$refs.submit.preload = false })
    //     .then(res => {
    //       this.$modal.hide('crew')
    //       this.$router.push({ name: 'climbing-mountain-crew-detail', params: { id: res.data.id } })
    //     })
    // },
    fetchItems() {
      this.table_preloader = true
      getClimbingMountainCrewList({
        page: this.pagination.page,
        page_size: 40,
        search: this.search,
        role: this.search ? '' : this.role_filter,
        rank: this.rank_filter
      }).then(res => {
        this.table.items = res.data.results
        this.pagination.pages = res.data.pages
        this.pagination.count = res.data.count
        this.is_loaded = true
        this.table_preloader = false
      })
    },
    onChangeRole() {
      this.pagination.page = 1
      this.fetchItems()
    },
    onChangeFilter() {
      this.pagination.page = 1
      this.search = ''
      this.fetchItems()
    },
    getUserAvatar(crop_url, gender) {
      if (crop_url) return crop_url
      else {
        if (!gender) {
          return require('@/assets/img/temp/avatar-slug.jpg')
        } else if (gender === 'male') {
          return require('@/assets/img/temp/avatar-slug-male.jpg')
        } else if (gender === 'female') {
          return require('@/assets/img/temp/avatar-slug-female.jpg')
        }
      }
    },
    dateFormat(date) {
      return format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy')
    },
    onCopyContactLink(link) {
      navigator.clipboard.writeText(link)
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Copied to clipboard',
          })
        })
        .catch(() => { console.error('Something went wrong') })
    },
    onCrewSearch() {
      this.searchCrew(this)
    },
    searchCrew: debounce(vm => {
      vm.pagination.page = 1
      vm.fetchItems()
    }, 350),
    onClickPagination(page) {
      this.pagination.page = page
      this.fetchItems()
    },
  }
}
</script>
